import { createAction } from '@ngrx/store';

export const initSSA = createAction(
    '[Main/Init] Init app data and trigger initial navigation'
);
